const monthDayYear = (date) => {
  return new Date(+date).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

module.exports = { monthDayYear };
